var _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle6, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle7, _path11, _circle8, _circle9, _polygon, _path12, _rect17, _rect18, _rect19, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e28f841e-1350-4768-a008-2029cc8c67c6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 939.03344,
    height: 827.5,
    viewBox: "0 0 939.03344 827.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M601.6632,863.27148c-.22949-.375-5.64062-9.41015-7.5166-28.17187-1.7207-17.21289-.61426-46.22656,14.43262-86.69824,28.50586-76.6709-6.56934-138.53321-6.92774-139.14942l1.73047-1.0039c.09082.15625,9.1416,15.92871,14.48828,41.04394a179.0612,179.0612,0,0,1-7.416,99.80664c-28.457,76.54-7.30078,112.77344-7.084,113.13086Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 460.03344,
    cy: 555.5,
    r: 13,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.03344,
    cy: 603.5,
    r: 13,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.03344,
    cy: 635.5,
    r: 13,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.03344,
    cy: 662.5,
    r: 13,
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.03344,
    cy: 704.5,
    r: 13,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M609.51672,863.75s-13-32,26-56Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M593.52873,863.16953s-5.91641-34.02934-51.7085-33.73768Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 163.03344,
    y: 457.54004,
    width: 2,
    height: 250.91992,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224.03344,
    y: 418.93018,
    width: 2,
    height: 328.14014,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 285.03344,
    y: 408,
    width: 2,
    height: 350,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 346.03344,
    y: 418.93018,
    width: 2,
    height: 328.14014,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 407.03344,
    y: 457.54004,
    width: 2,
    height: 250.91992,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 131.93334,
    y: 499,
    width: 308.19971,
    height: 2,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111.03344,
    y: 582,
    width: 350,
    height: 2,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.93334,
    y: 665,
    width: 308.19971,
    height: 2,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.03344,
    cy: 326,
    r: 175,
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 466.03344,
    y: 291.54004,
    width: 2,
    height: 250.91992,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 527.03344,
    y: 252.93018,
    width: 2,
    height: 328.14014,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 588.03344,
    y: 242,
    width: 2,
    height: 350,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 649.03344,
    y: 252.93018,
    width: 2,
    height: 328.14014,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 710.03344,
    y: 291.54004,
    width: 2,
    height: 250.91992,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 434.93334,
    y: 333,
    width: 308.19971,
    height: 2,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 414.03344,
    y: 416,
    width: 350,
    height: 2,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 434.93334,
    y: 499,
    width: 308.19971,
    height: 2,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M854.78243,69.32807h-.00013c-48.13946,0-87.16421,43.30889-87.16421,96.73311v67.876h20.87556l12.08576-25.14862-3.02147,25.14862H931.738l10.98707-22.86238-2.74674,22.86238h15.10723V180.64237C955.08557,119.16524,910.17832,69.32807,854.78243,69.32807Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M812.7082,191.32344s27.20587,63.48036-9.06862,76.17643l36.27449,119.70582,61.66663-3.62745,16.32352-39.90194-3.62745-59.85291-5.44117-39.90194s-38.08822,9.06863-34.46077-58.03918Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M798.1984,265.68615s-59.85291-5.44117-54.41173,38.08821,10.88234,52.598,10.88234,52.598l5.44118,65.29409-32.647,19.951H696.62983s-94.31367,21.7647-47.15684,45.34312,63.48036-18.13725,63.48036-18.13725,87.05878,0,92.5-14.50979S798.1984,265.68615,798.1984,265.68615Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M914.27677,247.5489s56.22546-19.951,59.85291,23.57842,3.62745,47.15684,3.62745,47.15684l10.88234,61.66663s21.7647,54.41174,21.7647,70.73526,16.32352,67.1078,16.32352,67.1078,21.76469,70.73526-1.81373,68.92153S997.7081,510.539,997.7081,510.539l-48.97056-97.94113-14.5098-59.85291Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M807.267,258.43125H792.75723l-1.81373,76.17643s-23.57841,32.647,5.44118,61.66663l7.2549,47.15684L936.04146,437.99l9.06863-48.97057s18.13724-39.90193-7.2549-76.17642l-23.57842-74.36271H901.5807s29.40532,108.421-32.647,110.6372C818.14937,350.9312,807.267,258.43125,807.267,258.43125Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.88671,708.83a455.42436,455.42436,0,0,1-146.38,109.47c-.02-90.76,1.05-164.48,1.05-164.48s-7.7,77.9-17.48,171.81a452.43033,452.43033,0,0,1-176.56,35.62c-1.08,0-2.16,0-3.24-.02,49.9-179.3,122.69-384.8,124.7-390.47a1.26381,1.26381,0,0,0,.04-.12l4.39-14.64,1.87-6.23,1.96-6.53,2.66-8.88,117.89-3.62,3.3,7.41,11.21,25.23a9.733,9.733,0,0,1,2.75,1.29C967.26672,478.6,994.01672,584.92,1017.88671,708.83Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M941.48264,416.22528,798.1984,421.66646s-6.53947,48.97056,0,48.97056c1.81373,0,150.53914,12.69607,148.72541-9.06863S941.48264,416.22528,941.48264,416.22528Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.25733,
    cy: 124.88506,
    r: 50.96152,
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M879.56163,95.97483C870.80993,84.706,857.90185,77.5684,843.49234,77.5684h-1.71129c-32.99489,0-59.74238,29.85656-59.74238,66.68656v.00014h11.05571l1.78547-13.59037,2.61786,13.59037h65.57081l5.4936-11.4977-1.37343,11.4977h12.89965q9.02914,44.84107-25.9468,89.68213H876.1158l10.98706-22.99542-2.74674,22.99542h41.8883l8.24033-52.8896C934.48475,141.43822,911.47052,107.85023,879.56163,95.97483Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.12193,
    cy: 32.64704,
    r: 32.64704,
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 522.61982,
    cy: 416.87958,
    r: 16.41361,
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "522.62 416.88 164.803 416.88 164.803 272.44 462.437 272.44 522.62 416.88",
    fill: "#efefef"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M654.73805,454.22382H251.51672v-177.267h330.099l.2789.67695ZM253.7052,452.03534h397.763L580.15069,279.14529H253.7052Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 223.89207,
    y: 295.41885,
    width: 178.36126,
    height: 16.41361,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 223.89207,
    y: 329.34031,
    width: 178.36126,
    height: 16.41361,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 223.89207,
    y: 363.26178,
    width: 178.36126,
    height: 16.41361,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.48328,622.59618a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,142.48328,622.59618Zm0-22a10,10,0,1,0,10,10A10.01114,10.01114,0,0,0,142.48328,600.59618Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M564.31092,170.886H544.56977V151.14489h19.74115Zm-18.2226-1.51855h16.70405v-16.704H546.08832Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.95479,174.96612l-13.4651-14.43621,14.43621-13.46509L205.391,161.501ZM179.636,160.60461l11.39354,12.21526,12.21525-11.39354L191.8512,149.21107Z",
    transform: "translate(-130.48328 -36.25)",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.c3fd6c0d7e3ff2f68ab4548dbe6a542b.svg";
export { ForwardRef as ReactComponent };